import rootPath from "../routes-path";
import { RouteProps as BaseRouteProps } from "../routes-path";
export { RouteProps } from "../routes-path";

export interface HlasovaniRouteProps extends BaseRouteProps {
    specificationId: string;
}

export const path = "/ankety-a-hlasovani";

export default rootPath + path;